import { lazy } from 'react';

// project import
import Loadable from "./../components/Loadable"; 
import MinimalLayout from "./../layout/MinimalLayout";

import SendEmailCodeForm from '../pages/authentication/forms/reset-password-forms/SendEmailCodeForm'
import ResetSuccessForm from '../pages/authentication/forms/reset-password-forms/ResetSuccessForm';
import VerifyCodeForm from '../pages/authentication/forms/registration-forms/VerifyCodeForm';
import InvitationForm from '../pages/authentication/forms/registration-forms/InvitationForm';
import EmailConfirmationForm from '../pages/authentication/forms/registration-forms/EmailConfirmationForm';
import RegisterSuccessForm from '../pages/authentication/forms/registration-forms/RegisterSuccessForm';

// render - login
const AuthLogin = Loadable(lazy(() => import( './../pages/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('./../pages/authentication/forms/registration-forms/Register')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'invitation_form',
      element: <InvitationForm />
    },
    {
      path: 'register',
      element: <AuthRegister />
    },
    {
      path: 'confirm_email',
      element: <EmailConfirmationForm />
    },
    {
      path: 'register_success',
      element: <RegisterSuccessForm />
    },
    {
      path: 'forget_password',
      element: <SendEmailCodeForm />
    },
    {
      path: 'verify_code',
      element: <VerifyCodeForm />
    },
    {
      path: 'reset_success',
      element: <ResetSuccessForm />
    }
  ]
};

export default LoginRoutes;
